// extracted by mini-css-extract-plugin
export default {"sponsored_crust":"social-section-core-SponsoredCrust__sponsored_crust--3R1TL","member":"social-section-core-SponsoredCrust__member--3PC_y"};